// Email regex - Standard email validation
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

// Phone number regex - Indian phone (with or without +91 prefix, 10 digits)
export const PHONE_REGEX = /^(?:\+91)?[6-9]\d{9}$/

// PAN number regex - Indian PAN format: AAAA A AAAA A ZZZ (5 letters, 4 digits, 1 letter)
export const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/

// Aadhaar number regex - Indian Aadhaar: 12 digits
export const AADHAAR_REGEX = /^[0-9]{12}$/

// Validation functions
export const validateEmail = (email: string): boolean => {
  if (!email) return false
  return EMAIL_REGEX.test(email.trim())
}

export const validatePhone = (phone: string): boolean => {
  if (!phone) return false
  // Remove spaces and special characters for validation
  const cleaned = phone.replace(/[\s\-()]/g, '')
  return PHONE_REGEX.test(cleaned)
}

export const validatePAN = (pan: string): boolean => {
  if (!pan) return false
  return PAN_REGEX.test(pan.trim().toUpperCase())
}

export const validateAadhaar = (aadhaar: string): boolean => {
  if (!aadhaar) return false
  // Remove spaces for validation
  const cleaned = aadhaar.replace(/\s/g, '')
  return AADHAAR_REGEX.test(cleaned)
}

// Format functions (optional, for masking input)
export const formatPhoneNumber = (phone: string): string => {
  const cleaned = phone.replace(/[\s\-()]/g, '')
  if (cleaned.length <= 10) {
    return cleaned
      .replace(/(\d{5})(\d{5})/, '$1 $2')
  }
  return cleaned
}

export const formatAadhaarNumber = (aadhaar: string): string => {
  const cleaned = aadhaar.replace(/\s/g, '')
  if (cleaned.length <= 12) {
    return cleaned
      .replace(/(\d{4})(\d{4})(\d{4})/, '$1 $2 $3')
      .trim()
  }
  return cleaned
}

// Password validation - Strong password requirements
// At least 8 characters, 1 digit, 1 uppercase, 1 lowercase, 1 special character
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/

export const validatePassword = (password: string): boolean => {
  if (!password) return false
  return PASSWORD_REGEX.test(password)
}

export const getPasswordStrengthMessage = (): string[] => {
  return [
    'At least 8 characters',
    'At least 1 uppercase letter (A-Z)',
    'At least 1 lowercase letter (a-z)',
    'At least 1 digit (0-9)',
    'At least 1 special character (!@#$%^&*)',
  ]
}
